import { keyframes } from '@emotion/react';
export const overlayEnter = keyframes({
    from: {
        opacity: 0,
    },
    to: {
        opacity: 1,
    },
});
export const overlayExit = keyframes({
    from: {
        opacity: 1,
    },
    to: {
        opacity: 0,
    },
});
